export const sliceForShowMore = <T>(
  items: T[],
  showAll: boolean,
  previewCount: number
): T[] =>
  showAll || items.length <= previewCount
    ? items
    : items.slice(0, previewCount)
